var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRewriteAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49957 5.93301L4.99957 7.33301L6.39957 4.83301L4.99957 2.33301L7.49957 3.73301L9.99957 2.33301L8.59957 4.83301L9.99957 7.33301L7.49957 5.93301ZM19.4996 15.733L21.9996 14.333L20.5996 16.833L21.9996 19.333L19.4996 17.933L16.9996 19.333L18.3996 16.833L16.9996 14.333L19.4996 15.733ZM21.9996 2.33301L20.5996 4.83301L21.9996 7.33301L19.4996 5.93301L16.9996 7.33301L18.3996 4.83301L16.9996 2.33301L19.4996 3.73301L21.9996 2.33301ZM13.3396 13.113L15.7796 10.673L13.6596 8.55301L11.2196 10.993L13.3396 13.113ZM14.3696 7.62301L16.7096 9.96301C17.0996 10.333 17.0996 10.983 16.7096 11.373L5.03957 23.043C4.64957 23.433 3.99957 23.433 3.62957 23.043L1.28957 20.703C0.89957 20.333 0.89957 19.683 1.28957 19.293L12.9596 7.62301C13.3496 7.23301 13.9996 7.23301 14.3696 7.62301Z",
    fill: "#EF965A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewriteAi);
export default __webpack_public_path__ + "static/media/rewrite-ai.3a5abd11.svg";
export { ForwardRef as ReactComponent };